import React from 'react';
import styles from './SendMessageStep.module.css';
import { EmailSetup } from './EmailSetup';
import { SMSSetup } from './SMSSetup';
import { MergeFields } from './MergeFields';
import type { SendMessageFormField } from './types';

interface SendMessageFormProps {
  subject: string;
  previewText: string;
  html: string;
  css: string;
  text: string;
  onChange: (field: SendMessageFormField, value: string | boolean) => void;
  onOpenStripoEditor: () => void;
  sendToPointOfContact: boolean;
}

export const SendMessageForm: React.FC<SendMessageFormProps> = ({
  subject,
  previewText,
  html,
  css,
  text,
  onChange,
  onOpenStripoEditor,
  sendToPointOfContact,
}) => (
  <form className={styles.form}>
    <EmailSetup
      subject={subject}
      previewText={previewText}
      html={html}
      css={css}
      onSubjectChange={value => onChange('subject', value)}
      onPreviewTextChange={value => onChange('previewText', value)}
      onOpenEditor={onOpenStripoEditor}
      sendToPointOfContact={sendToPointOfContact}
      onSendToPointOfContactChange={value => onChange('sendToPOC', value)}
    />
    <SMSSetup defaultValue={text} onChange={value => onChange('text', value)} />
    <MergeFields />
  </form>
);
